import { defineComponent as _defineComponent } from 'vue';
import { X } from "lucide-vue-next";
import { reactiveOmit } from "@vueuse/core";
import { DialogClose, DialogContent, DialogPortal, useForwardPropsEmits, } from "reka-ui";
import { cn } from '../../primitives/utils';
import SheetOverlay from "./SheetOverlay.vue";
export default /*@__PURE__*/ _defineComponent({
    ...{
        inheritAttrs: false,
    },
    __name: 'SheetContent',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        side: { type: String, required: false, default: "right" },
        disablePortal: { type: Boolean, required: false, default: false },
        showCloseButton: { type: Boolean, required: false, default: true },
        forceMount: { type: Boolean, required: false },
        disableOutsidePointerEvents: { type: Boolean, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false }
    },
    emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const delegatedProps = reactiveOmit(props, "class", "side", "disablePortal", "showCloseButton");
        const forwarded = useForwardPropsEmits(delegatedProps, emits);
        const __returned__ = { props, emits, delegatedProps, forwarded, get X() { return X; }, get DialogClose() { return DialogClose; }, get DialogContent() { return DialogContent; }, get DialogPortal() { return DialogPortal; }, get cn() { return cn; }, SheetOverlay };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
